export enum OrderStatus {
    RECIBIDO = 'Nuevo pedido',
    ARMADO = 'Tu orden ha sido aceptada',
    LISTO = 'Orden lista para entrega',
    EN_ENTREGA = 'La orden salió de la tienda',
    TERMINADO = 'Orden entregada',
    RECHAZADO = 'Orden rechazada',
    RETENIDO = 'Orden retenida, comunicarse con la tienda',
    CANCELADO = 'Orden cancelada'
}
